










































import { defineComponent } from '@vue/composition-api';
import { Routes } from '@front-app/constants/routes';
import { Location } from 'vue-router';
import TrButton from '@front-app/components/buttons/TrButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default defineComponent({
	components: {
		TrButton,
		FontAwesomeIcon,
	},
	props: {
		category: {
			type: String,
			required: true,
		},
		isRemoveButton: Boolean,
		isNew: Boolean,
	},
	setup() {
		const categoryLink = (category: string): Location => ({ name: Routes.GROUP_CONTENT, query: { categories: [category] } });

		return {
			categoryLink,
		};
	},
});
